<template>
  <div id="app">
    <Stepper></Stepper>
    <router-view></router-view>
  </div>
</template>
<script>
import Service from "@/service/backend-api";
import { changeLanguage } from "@/i18n";
import i18n from "@/i18n";
import Stepper from "./components/stepper";

export default {
  name: "app",
  components: {
    Stepper,
  },  
  data() {
    return {
      errors: []
    };
  },
  created() {
    console.log("App Created-Invoked");

    if (
      this.$route.query.hasOwnProperty("lang") &&
      this.$route.query.lang != ""
    ) {
      this.$store.state.lang = this.$route.query.lang;
    }
    changeLanguage(this.$store.state.lang);
    this.setLanguage();
    this.getAllowedCharacters();
  },
  mounted() {
    console.log("App Mounted-Invoked");
    Service.getModuleName()
      .then(({ data }) => {
        this.$store.state.ModuleName = data;
        console.log(this.$store.state.ModuleName);
        this.$nextTick(() => {
          var moduleName = this.$store.state.ModuleName;
          if (moduleName.includes("airplus") || moduleName.includes("device")) {
            document.title = i18n.t("device.title.header");
          } else {
            document.title = i18n.t("application.page.title");
          }
        });
      })
      .catch(error => {
        console.log(error.response.data);
      });
  },
  methods: {
    getAllowedCharacters: function() {
      Service.getAllowedChars()
        .then(({ data }) => {
          this.$store.state.allowedNameChars = data.name;
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    setLanguage: function() {
      Service.setLanguage(this.$store.state.lang)
        .then(({ data }) => {
          console.log(data);
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
  }
};
</script>
